export * from "./arrow-left-icon.component"